<template>
  <div class="container">
    <div class="header">
        <img src="../../assets/images/company-log.png" alt="">
    </div>
    <div class="swiper">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="item in bannerList" :key="item.code">
            <img :src="item.src" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="module-info">
      <div class="module-item">
        <div class="tip-info">
          <img src="../../assets/images/suit.png" alt="">
          <p class="title-topic">免联考在职国际学位项目</p>
        </div>
        <div class="degree-type">
          <div class="item" v-for="item in degreeList" :key="item.id" @click="jumpEducation(item.id)">
              <div class="degree-img">
                  <img :src="item.imgUrl" alt="">
                  <div class="logo-container">
                    <img class="logo-img" :src="item.logoUrl" alt="">
                  </div>
              </div>
              <ul class="degree-list">
                  <li>{{ item.name }}</li>
                  <li>{{ item.school }}</li>
                  <li class="item-englishName">{{ item.englishName }}<span></span></li>
                  <li class="item-honor">{{ item.honor }}</li>
                  <li class="item-attest">{{ item.attest }}</li>
              </ul>
          </div>
        </div>
        <div class="degree-type" v-if="isShow">
          <div class="item" v-for="item in moreDegreeList" :key="item.id" @click="jumpEducation(item.id)">
              <div class="degree-img">
                  <img :src="item.imgUrl" alt="">
                  <div class="logo-container">
                    <img class="logo-img" :src="item.logoUrl" alt="">
                  </div>
              </div>
              <ul class="degree-list">
                  <li>{{ item.name }}</li>
                  <li>{{ item.school }}</li>
                  <li class="item-englishName">{{ item.englishName }}<span></span></li>
                  <li class="item-honor">{{ item.honor }}</li>
                  <li class="item-attest">{{ item.attest }}</li>
              </ul>
          </div>
        </div>
      </div>
      <div class="more-subject" v-if="!isShow" @click="getMoreDegree">
        <span class="btn">更多项目</span>
      </div>
    </div>
    <div class="module-item advantage-item">
        <img :src="imageSrc1">
    </div>
    <div class="module-info">
        <img class="mid-map" :src="imageSrc2">
    </div>
    <div class="footer">
      <div class="company-info">
        <span>地址 ：深圳市南山区桃花园路8号田厦国际中心A座2406/2408/2409/2410</span>
        <span>电话 ：0755-82947408（咨询热线）   0755-88379747（合作热线）</span>
        <span>网址 ：http://www.china-aiei.com</span>
        <span>邮箱 ：ymword@china-aiei.com</span>
      </div>
      <div class="dingbu">
        <img src="../../assets/images/Abundance.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import * as Apis from '@/apis'
import {  Message } from 'element-ui'
import Axios from 'axios'
import wx from 'weixin-js-sdk'
export default {
  name: 'index',
  data () {
      return {
          // 学位项目列表
          logoImage: '',
          degreeList: [],
          // 轮播图数据
          bannerList: [],
          moreDegreeList: [], // 更多项目数据
          isShow: false,
          imageSrc1: '',
          ul:'',
      }
  },
  mounted(){ 
      var ul = window.location.href.split("#")[0]  //获取当前URL
      //ul = encodeURIComponent(window.location.href)
      Axios.get('http://img.chinaaiei.com:8000/apitest/signature_api',{
        params:{
          us : ul
        }
      }).then(res => {  
      console.log(res.data)
        wx.config({       
        debug: false, // 开启调试模式,开发时可以开启                  
        appId:"wx8a5bb93568fc82e8",  //appId: res.appId,   // 必填，公众号的唯一标识   由接口返回
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳 由接口返回
        nonceStr: res.data.nonceStr,    // 必填，生成签名的随机串 由接口返回
        signature: res.data.signature,   // 必填，签名 由接口返回
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'wx.onMenuShareWeibo'] // 此处填你所用到的方法
        });
      }).catch((error) => {
        console.log();//异常
        });
      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({ 
        title: '富有国际教育——让国际优质学位项目尽在掌握！', // 分享标题
        desc: '', // 分享描述
        //link: 'http://degree.chinaaiei.com/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        link: window.location.href.split("#")[0],
        imgUrl: 'http://img.chinaaiei.com:8000/media/shouye3/11222.jpg', // 分享图标
        success: function () {
                // 设置成功
         }
        });
        wx.updateTimelineShareData({ 
        title: '富有国际教育——让国际优质学位项目尽在掌握！', // 分享标题
        link: window.location.href.split("#")[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://img.chinaaiei.com:8000/media/shouye3/11222.jpg', // 分享图标
        success: function () {
        // 设置成功
          }
        })
      });
    },
  methods: {
    async getIndexImages() {
      const self = this
      const {
        success,
        data,
        message
      } = await Apis.indexImages()
      if (success) {
        const info = data.bannerList
        self.bannerList = info
        console.log(self.bannerList)
      } else {
        Message.error(message)
      }
    },
    async getIndexGegree() {
      const self = this
      const {
        success,
        data,
        message
      } = await Apis.indexDegreed()
      if (success) {
        const info = data.degreeList
        self.degreeList = info
      } else {
        Message.error(message)
      }
    },
    // 更多项目
    async getMoreGegreeList() {
      const self = this
      const {
        success,
        data,
        message
      } = await Apis.indexDegree()
      if (success) {
        const info = data.degreeList
        self.moreDegreeList = info
      } else {
        Message.error(message)
      }
    },
    getMoreDegree() {
      this.isShow = true
      this.getMoreGegreeList()
    },
    async getShouyeImage() {
      const self = this
      const {
        success,
        data,
        message
      } = await Apis.indexShouye()
      if (success) {
        const info = data.shouye
        self.imageSrc1 = info[0].src1
        self.imageSrc2 = info[0].src2
      } else {
        Message.error(message)
      }
    },
    jumpEducation(queryId) {
      this.$router.push({
        path: '/education',
        query: {
          id: queryId
        }
      })
    }
  },
  created() {
    this.getIndexImages()
    this.getIndexGegree()
    this.getShouyeImage()
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.container {
  width 100%
  overflow hidden
  .header {
    background #EF862F
    width 100%
    padding 17px 0
    img {
        display block
        height 100px
        width 340px
        margin 0 auto
    }
  }
   
  .swiper {
     width 100%
     overflow hidden
     img {
         width 100%
         height 250px
     }
  }
  .module-info {
    padding 0 14px
    .mid-map {
        width 100%
        //margin-top 40px    (2020.2.28修改首页最后图片)
    }
  }
    .module-item {
      padding-top 40px
      .tip-info {
        text-align center
        color #977668
        img {
            width 45%
            height 74px
            margin 0 auto
        }
        h1 {
          font-weight bold
          box-sizing border-box
        }
        .title-topic {
          font-size 34px
          padding 20px 0 10px
          box-sizing border-box
        }
      }
      .degree-type {
        display flex
        flex-wrap wrap
        display -webkit-flex
        justify-content space-between
        flex-direction row
        width 100%
        .item {
          margin 20px 0 20px 0
          height 425px
          border-radius 10px
          box-shadow: 10px 10px 5px #E0DFDF;
          width: 48%
          &:last-of-type {
            margin-right 0
          }
          .degree-list {
            margin-top 20px
            li {
              font-size 12px
              line-height 38px
              padding-left 20px
            }
            .item-honor {
              color #F28D3A
            }
            .item-attest {
              color #977668
            }
            .item-englishName {
              span {
                display block
                width 50%
                margin-top 8px
                border-bottom 1px solid #CACACA
              }
            }
          }
          .degree-img {
            position relative
            img {
              width 100%
              border-radius 10px
            }
            .logo-container {
                position absolute
                right 0
                bottom -50px
                .logo-img {
                    width 140px
                    height 80px
                    transform: translateY(-10px)              //logo移动2020.2.28
                }
            }
          }
        }
      }
    }
    .advantage-item {
      padding-bottom 40px
      img {
          width 100%
      }
      .tip-info {
        color #fff
      }
      .degree-type {
        display flex
        padding 0 14px
        box-sizing border-box
        .item {
          height 190px
          box-shadow none
        }
      }
    }
    .more-subject {
      width 100%
      margin 34px 0
      .btn {
        display block
        margin 0 auto
        width 300px
        height 60px
        text-align center
        line-height 60px
        font-size 26px
        color #fff
        border-radius 10px
        background #977668
      }
    }
  .footer {
    margin-top 40px
    padding 14px
    background #F0862F
    color #fff
    display flex
    box-sizing border-box
    .company-info {
      position relative
      flex 1
      padding 16px 0px 16px 30px
      span {
        display block
        font-size 14px
        line-height 36px
      }
    }
      .dingbu {
        position absolute
        img {
        display block
        height 120px
        width 120px
        padding-left  580px
        padding-top  40px
        //margin-top  60px
        //margin-left   550px
      }
    }
  }
}
</style>
<style lang="stylus">
.van-swipe__indicators {
  display none !important
}
</style>
